import { LocationStrategy } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppTexts, ScreenNames } from '../objects/app-static-texts';
import { GoogleAnalyticsEventsService } from './google-analytics-events.service';

declare global {
  interface Window {
    parentIFrame:any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class AppManagementService {
  // DEFAULT HEADER
  apiCallHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': '*',
      'Access-Control-Allow-Headers': '*'
    })
  };

  startScreen:any;
  clientSessionId: any;

  selfie_apiCallHeaders: { headers: HttpHeaders; };

  previous_screen_name:any;

  current_screen_path: any;

  // UI APP VERSION
  ui_app_version :any;

  apiURL: null;
  apiType: null;

  quizType: String ="inline";

  backClick: boolean = true;

  // GET CLIENT QUIZ JSON
  client_json_obj:any;

  selectedOptions: any;

  app_load_id:any;
  appPageDesign: any;
  currentPage: any;
  client_config:any;
  isMobile: boolean =false;
  isTablet: boolean =false;
  isDesktop: boolean =false;

  previewQuiz: boolean = false;

  screenHistory = [];

  currentWindow: any;

  constructor(
    private router: Router,
    private http: HttpClient,
    public location: LocationStrategy,
    private googleAnalyticsService: GoogleAnalyticsEventsService) {
      location.onPopState(() => {
        if(this.appPageDesign!=undefined){
          this.setNextPageId(this.appPageDesign.back_page_id);
        }
        if(this.getPageDesign()!=undefined){
          // this.router.navigateByUrl('/' + this.getPageDesign().name);
          this.router.navigate(["/" + this.getPageDesign().name], { queryParamsHandling: 'preserve' });
          this.scrollToTop();
        }
      });

  }

  scrollToTop(){
    var message = { type: AppTexts.page, key: 'scrollTop', value: '', quiz_type: this.quizType };
    // window.parent.postMessage("scrollTop", '*');
    this.sendToIframe(message);
  }

  setQuizType(type){
    this.quizType = type;
  }

  sentHeight(height){
    var message = { type:AppTexts.page, key: 'iframe-height', value: height, quiz_type: this.quizType };
    this.sendToIframe(message);
  }

  // LOADING FIRST SCREEN
  startApp() {
    // FIRST SCREEN NAME
    this.startScreen = this.client_json_obj.config.pages[0];
    this.appPageDesign = this.getAppConfigForKey(this.startScreen);
    this.client_config = this.client_json_obj.config.client;
    this.apiURL = this.client_config.api_url;
    if(this.client_config.api_type!=undefined){
      this.apiType = this.client_config.api_type;
      // SETTING API HEADER TYPES
      switch (this.apiType) {
        case 'hair':
          this.selfie_apiCallHeaders = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': this.client_config.credential_b64
            })
          }
          break;
        default:
          this.selfie_apiCallHeaders = this.apiCallHeaders;
          break;
      }
    }

    // LOAD FONTS
    if(this.client_json_obj.config.fonts!=undefined){
      this.addFontFamily();
    }
  }

  // LOAD CUSTOM FONTS THROUGH URL
  addFontFamily(){  
    if(this.client_json_obj.config.fonts!=undefined){
      var fonts_list = this.client_json_obj.config.fonts;
      for (var key in fonts_list) {
        if (fonts_list.hasOwnProperty(key)) {
          var junction_font = new FontFace(key, 'url('+fonts_list[key]+')');
          junction_font.load().then(function(loaded_face) {
            (document as any).fonts.add(loaded_face);
          }).catch(function(error) {
            console.log("Error loading font ",error);
          });
        }
      }

      // FOR PRIMALLY AND CLIENTS WITH PREVIOUS JSON DESIGN
      if(fonts_list.length>0){
        for(var f=0;f<fonts_list.length;f++){
          var font_name = this.client_json_obj.config.fonts[f].font_name;
          var font_url = this.client_json_obj.config.fonts[f].font_url;
          var junction_font = new FontFace(font_name, 'url('+font_url+')');
          junction_font.load().then(function(loaded_face) {
            (document as any).fonts.add(loaded_face);
          }).catch(function(error) {
            console.log("Error loading font ",error);
          });
        }
      }
    }
  }

  getCameraOverlayObject(){
    if(this.client_json_obj.config.basic.camera_overlay!=undefined){
      return this.client_json_obj.config.basic.camera_overlay;
    }
    else{
      return false;
    }
  }

  getApiToServerDataRequests(){
    if(this.client_json_obj.config.basic.api_response_2_server!=undefined){
      return this.client_json_obj.config.basic.api_response_2_server;
    }
    else{
      return false;
    }
  }

  getCameraOverlayText(){
    if(this.client_json_obj.config.basic.camera_overlay.text!=undefined){
      return this.client_json_obj.config.basic.camera_overlay.text;
    }
    else{
      return null;
    }
  }

  getCameraOverlayImg(){
    if(this.client_json_obj.config.basic.camera_overlay.img_url!=undefined){
      return this.client_json_obj.config.basic.camera_overlay.img_url;
    }
    else{
      return null;
    }
  }

  //Setting loaded device type
  setDeviceType(mob, tab, desktop) {
    this.isMobile = mob;
    this.isTablet = tab;
    this.isDesktop = desktop;
  }

  //Fetching style for an Element
  applyElementStyle(element){
    var fullStyle = {};
    var mobStyle = {};
    var tabStyle = {};
    
    if(element!=undefined){
      var commonClassList =[];
      if(element.classes!=undefined){
        commonClassList = element.classes.common;
        
        if(commonClassList!=undefined){
        
          if (commonClassList.length > 0) {
            fullStyle = this.applyStyles(commonClassList);
          }
        
          var idStyle = this.getCSSforID(element.id);
          if (idStyle != undefined) {
            fullStyle = Object.assign(fullStyle, idStyle);
          }
        }
        
        var mobileClassList = [];
        mobileClassList = element.classes.mobile;
        
        if (this.isMobile) {
          if(mobileClassList!=undefined){
            if (mobileClassList.length > 0) {
              mobStyle = this.applyStyles(mobileClassList);
              fullStyle = Object.assign(fullStyle, mobStyle);
            }
          }
        }

        var tabClassList = [];
        if(element.classes.tablet!=undefined){
          tabClassList = element.classes.tablet;
        }
        
        if (this.isTablet) {
          if(tabClassList!=undefined){
            if (tabClassList.length > 0) {
              tabStyle = this.applyStyles(tabClassList);
              fullStyle = Object.assign(fullStyle, tabStyle);
            }
          }
        }
      }
    }
    
    return fullStyle;
  }

  //Fetching styles from list
  applyStyles(classList) {
    var styleC = {};
    if(classList !=undefined){
      if (classList.length > 0) {
        for (var cl = 0; cl < classList.length; cl++) {
          var style = this.getCSSforClass(classList[cl]);
          styleC = Object.assign(styleC, style);
        }
      }
    }
    return styleC;
  }

  setNextPageId(pageId) { this.appPageDesign = this.getAppConfigForKey(pageId); }

  //Enabler for footer with company logo
  enablePoweredBy(){
    return this.client_json_obj.config.basic.enable_poweredBy;
  }

  getSurvey(){
    return this.client_json_obj.config.survey;
  }

  //Initial Call - Fetching JSON for complete app design
  getClientDesignJson(shopId,formId): Observable<Response>{
    this.app_load_id = {
      shop_id:shopId,
      form_id:formId
    };

    // Enable Cache (&cache=false) for dev purpose
    // var localUrl = "https://service.tangent.ai/shopify/get-config?shop_id="+shopId+"&form_id="+formId+"&cache=false";
    var localUrl = "https://service.tangent.ai/shopify/get-config?shop_id="+shopId+"&form_id="+formId;
    return this.http.get<Response>(localUrl);
  }

  getNewSessionId(data): Observable<Response>{
    var localUrl = "https://s.tangent.ai/track?client="+data.client+"&form_id="+data.form_id;
    return this.http.get<Response>(localUrl);
  }

  saveQuizJSON(json) {
    this.client_json_obj = json;
    this.startApp();

    // PRE LOAD IMAGES FROM URL
    const dataString = JSON.stringify(json);
    const imageUrls = dataString.match(/(http)?s?:?(\/\/[^"']*\.(?:png|jpg|jpeg|gif|png|svg))/g)
    for (let i = 0; i < imageUrls.length; i++) {
      var img=new Image();
      img.src=imageUrls[i];
    }
  }

  loadPrevious(){
    if(this.screenHistory.length>0){
      
      this.previous_screen_name = this.screenHistory[this.screenHistory.length-1];
      if(this.appPageDesign!=undefined){
        if(this.previous_screen_name.name == this.appPageDesign.name){
          this.previous_screen_name = this.screenHistory.pop();
        }
      }
      this.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,'Back','');
      
      if(this.previous_screen_name.type == AppTexts.page){
        this.screenHistory.pop();
        this.setNextPageId(this.previous_screen_name.name);
        // this.router.navigateByUrl('/' + this.previous_screen_name.name);
        this.router.navigate(["/" + this.previous_screen_name.name], { queryParamsHandling: 'preserve' });
         this.scrollToTop();
      }
      if(this.selectedOptions!=undefined){
        if(this.previous_screen_name.type == AppTexts.question){
          this.setNextPageId(ScreenNames.survey);
          // this.router.navigateByUrl('/survey');
          this.router.navigate(["/"+ScreenNames.survey], { queryParamsHandling: 'preserve' });
           this.scrollToTop();
        }
      }
      else{
        this.screenHistory = this.screenHistory.filter(function( obj ) {
          return obj.type !== AppTexts.question;
        });
      }
    }
  }

  setPreviewQuizStatus(status){ this.previewQuiz = status; }

  saveSelectedQueries(selected) { this.selectedOptions = selected; }
  
  sentEventData(eventName,
    eventCategory,
    eventAction,
    eventLabel,
    eventValue){
      if(!this.previewQuiz){
        if(eventAction=="Selected") { eventLabel = "Answer Tag"; }
        if(eventAction=="Changed") { eventLabel="AI Changed"; }

        var final_label = eventLabel.toLowerCase().trim();
        final_label = final_label.replace(/ /g,"_");
            
        var final_action = eventAction.toLowerCase().trim();
        final_action = final_action.replace(/ /g,"_");

        if(final_label=="back"){
          var s = this.current_screen_path.substr(0, this.current_screen_path.lastIndexOf("/"));
          if(this.previous_screen_name!=undefined){
            s=s+"/"+this.previous_screen_name.name;
            eventValue = {
              from: this.current_screen_path,
              to: s
            }
          }
        }
        this.saveEventToServer(final_label,final_action,this.current_screen_path,eventValue).subscribe(
          (data: {}) => { }, (error: {}) => { console.log('error : ', error); }
        );

        this.googleAnalyticsService.eventEmitter(eventName,eventCategory,eventAction,eventLabel);
      }
  }

  //UPDATING EVENT DATA TO SERVER
  saveEventToServer(eName, eType, ePath, eValue) : Observable<Response>{
      var session_id = this.getClientSessionId();
      let current_length = ePath.length;
      let final_path = ePath;
      var dataJson;
      if(current_length>99){
        final_path = ePath.substring(0, 99);
      }
      if(session_id!=undefined){
        dataJson = {
          "session_id": session_id,
          "event_type": eType,
          "event_name": eName,
          "page_uri": final_path
        }
        if(eValue!=undefined && eValue!=''){
          dataJson["attributes"] = eValue;
        }
      }
      var localUrl = 'https://s.tangent.ai/track';
      var httpOptions = this.getSelfiApiCallHeaders();
      return this.http.post<Response>(localUrl, dataJson, httpOptions);
  }

  getNormalSelectClass(qtn){
    var classes= [];
    //ADDING DEFAULT OPTIONS STYLE
    classes = classes.concat(this.client_json_obj.config.basic.normalSelectionClass);
    //IF PARTICULAR SCREEN HAS A STYLE FOR OPTIONS
    if(qtn.style!=undefined){
      if(qtn.style.common!=undefined){
        for(var c=0;c<qtn.style.common.length;c++){
          classes.push(qtn.style.common[c]);
        }
      }
      if(this.isMobile){ 
        if(qtn.style.mobile!=undefined){
          for(var m=0;m<qtn.style.mobile.length;m++){
            classes.push(qtn.style.mobile[m]);
          }
        }
      }
    }
    else{
      if(this.isMobile){
        classes.push(AppTexts.SurveyOptionMobWidth);
      }
    }
    return classes;
  }

  getSelectionHighlightCss(qtn){
    var classes= [];
    //ADDING DEFAULT OPTIONS HIGHLIGHT STYLE
    classes = classes.concat(this.client_json_obj.config.basic.highlightedOptionClass);
    //IF PARTICULAR SCREEN HAS A STYLE FOR OPTIONS
    if(qtn.style!=undefined){
      for(var c=0;c<qtn.style.common.length;c++){
        classes.push(qtn.style.common[c]);
      }
      //IF HIGHLIGHT IS HAVING PARTICULAR STYLE
      if(qtn.style.highlight!=undefined){
        for(var c=0;c<qtn.style.highlight.length;c++){
          classes.push(qtn.style.highlight[c]);
        }
      }
      if(this.isMobile){ 
        if(qtn.style.mobile!=undefined){
          for(var m=0;m<qtn.style.mobile.length;m++){
            classes.push(qtn.style.mobile[m]);
          }
        }
      }
    }
    return classes;
  }

  addToScreenHistory(sc_name,sc_type){
    var flag= true;
    if(this.screenHistory.length>0){
      for(var s=0;s<this.screenHistory.length;s++){
        if(this.screenHistory[s]["name"]==sc_name){      
          flag = false;
        }
      }
    }
    if(flag){
      var screen = {
        name: sc_name,
        type: sc_type
      }
      this.screenHistory.push(screen);
    }
  }

  removeFromScreenHistory(screen_name){
    if(this.screenHistory.length>0){
      for (var i=this.screenHistory.length-1; i>=0; i--) {
        if (this.screenHistory[i].name === screen_name) {
          this.screenHistory.splice(i, 1);
          break;
        }
      }
    }
  }

  // SEND DATA TO IFRAM THROUGH POST MESSAGE
  sendToIframe(msg){
    var data = JSON.stringify(msg);
    window.parent.postMessage(data, '*');
  }

  redirectAppToBase() { 
    this.router.navigate(["/"], { queryParamsHandling: 'preserve' });
    this.scrollToTop(); 
  }

  getAppVersion() { return this.ui_app_version; }
  
  getClientSessionId() { return this.clientSessionId; }

  getBackClick() { return this.backClick; }

  setBackClick(click) { this.backClick = click; }

  sentPostMessageToParent(message) { 
    window.parent.postMessage(message, '*'); 
  }

  getAppConfigForKey(key) { return this.client_json_obj[key]; }

  getConfiguratonDisplay(){ return this.client_json_obj.config["visual_report_display"]; }

  getSkinToneMapping(){ return this.client_json_obj.config.skintone_mapping; }

  getPageDesign() { return this.appPageDesign; }

  // GET STYLE USING CLASS NAME
  getCSSforClass(key) { 
    if(this.client_json_obj!=undefined){
      return this.client_json_obj.config.global_css.classes[key]; 
    }
    else{
      return null;
    }
  }
  
  // GET STYLE USING ID NAME
  getCSSforID(id) { return this.client_json_obj.config.global_css.ids[id]; }

  getAppLoadId() { return this.app_load_id; }

  setPreviousScreenName(screen_name) { this.previous_screen_name = screen_name; }

  getSubmitCallbackFunction() { return this.client_json_obj.config.final_submit_callback }

  getRedirectionData() { return this.client_json_obj.config.redirection; }

  getSelfieTagMatcher() { return this.client_json_obj.config.selfie_tag; }

  getClientApiData() { return this.client_json_obj.config.client.api_data_relations; }

  getAIpoweredImg() { return this.client_json_obj.config.basic.AI_powered_img.url; }

  getAIpoweredImgClass() { return this.applyStyles(this.client_json_obj.config.basic.AI_powered_img.class); }

  getCameraDimension() { return this.client_json_obj.config.basic.camera; }

  getServerReqDataFrmSelfie() { return this.client_json_obj.config.client.server_req_selfie_res; }

  getFormInputStyle(key) { return this.client_json_obj.config.global_css.classes[key]; }

  getClientApiType() { return this.apiType; }

  getClientApiURL() { return this.apiURL; }

  getSelfiApiCallHeaders() { return this.selfie_apiCallHeaders; }

  // Remove Last Screen From Screen Flow List
  popFromScreenHistory() { return this.screenHistory.pop(); }

  // Return Screen Flow List in App
  getScreenHistory() { return this.screenHistory; }

  // Return Entire ClientConfig
  getClientConfig() { return this.client_config; }

  getCustomLoader(key) { return this.client_json_obj.config.basic.loader[key]; }

}